import React from "react";
import Storage from "/src/utils/storage";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useNavigate } from "react-router-dom";
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import UserModalBodyAdmin from "./UserModalBodyAdmin"
import UserModalBodyUser from "./UserModalBodyUser"
import companyService from "../../../company/services/companyService"


import "./UserModal.css"
import "/src/assets/css/polices.css";

const UserModal = NiceModal.create(({ title, data }) => {

    const currentUser = Storage('local').get('user');

    const modal = useModal();

    const { onClose } = useModalHelper(modal);

    // A SUPPRIMER : form | pas utilise pour le moment car user modal body pas utilisee
    const form = { id: data == undefined ? null : data.id, username: data == undefined ? null : data.username }
   
    return (
        <SideModal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })}  >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            {currentUser.is_admin ?
                <UserModalBodyAdmin data={data} title={title}></UserModalBodyAdmin>
                :
                <UserModalBodyUser data={data}  title={title}></UserModalBodyUser> // PAS UTILISER POUR LE MOMENT 
            }


        </SideModal >
    )
});

export default UserModal;